// Spain
export const locale = {
  lang: 'es',
  data: {
    TRANSLATOR: {
      SELECT: 'Elige tu idioma',
    },
    MENU: {
      STAFF: 'Personal',
      ORDERS: 'Pedidos',
      MANAGE: 'Gestionar',
      CLIENTS: 'Clients',
      PRODUCTS: 'Products',
      FACTORIES: 'Suerte',
      REQUEST_FOR_QUOTES: 'Solicitud de cotizaciones',
      PENDING_ORDERS: 'Cotizaciones pendientes',
      PURCHASE_ORDERS: 'Ordenes de compra',
    },
    PAGINATOR: {
      ITEMS_PER_PAGE: 'Artículos por página',
      NEXT_PAGE_LABEL: 'Próxima',
      PREV_PAGE_LABEL: 'Anterior',
    },
    AUTH: {
      GENERAL: {
        BACK_BUTTON: 'Atrás para iniciar sesión',
        CONTACT: 'Contacto',
        FORGOT_BUTTON: 'Se te olvidó tu contraseña',
        GOOGLE_LOGIN: 'Inicie sesión o regístrese con Google',
        I_AGREE: 'Estoy de acuerdo con el',
        LEGAL: 'Legal',
        NO_ACCOUNT: '¿No tienes una cuenta?',
        OR: 'O',
        STATUS: 'Estado',
        PRIVACY: 'Intimidad',
        SIGN_OUT: 'Desconectar',
        SIGNUP_BUTTON: 'Regístrate',
        SUBMIT_BUTTON: 'Enviar',
        TERMS_CONDITIONS: 'Términos y condiciones',
      },
      LOGIN: {
        TITLE: 'Cuenta de inicio de sesión',
        BUTTON: 'Registrarse',
      },
      RECOVER: {
        LINK: 'Enlace expirado',
        NEW_PASSWORD: 'Nueva contraseña',
        CREATE_NEW_PASSWORD: 'Crear nueva contraseña',
        TITLE: 'Recuperar mi contraseña',
        BUTTON: 'Guardar nueva contraseña',
      },
      FORGOT: {
        TITLE: 'Recuperar mi contraseña',
        EMAIL_LABEL: 'Su dirección de correo electrónico de inicio de sesión',
        BUTTON: 'Recuperar mi contraseña',
      },
      REGISTER: {
        COMPLETE_DETAILS: 'Complete su registro usando',
        DESC: 'Ingrese sus datos para crear su cuenta',
        GOOGLE_ACCOUNT: 'Cuenta Google',
        LOGGING_IN: 'Iniciar sesión usando',
        LOGIN_DETAILS_TITLE: 'Detalles de registro',
        SUCCESS: 'Su cuenta ha sido registrada exitosamente.',
        TITLE: 'Registrar una cuenta nueva',
      },
    },
    GENERAL: {
      ABOUT: 'Acerca de',
      ADDRESS: 'Dirección',
      CHARGE: 'Cargar',
      CITY: 'Ciudad',
      CONTACT: 'Contacto',
      DAYS: 'Dias',
      DESTINATION: 'Destino',
      EMAIL_ADDRESS: 'Dirección de correo electrónico',
      FULLNAME: 'Nombre completo',
      HI: 'Hola',
      MY_PROFILE_DESC: 'Configuraciones de cuenta y más',
      MY_PROFILE: 'Mi perfil',
      CHANGE_PASSWORD: 'Cambia la contraseña',
      NAME: 'Nombre',
      NO: 'No',
      NUMBER: 'Número',
      PRICE: 'Precio',
      PRODUCT: 'Producto',
      QUANTITY: 'Cantidad',
      SAMPLE: 'Muestra',
      SHIPPING: 'Envío',
      SIGNATURE: 'Firma',
      STATE: 'Estado',
      SUCCESS: 'Éxito',
      TEAM: 'Equipo',
      TOTAL: 'Total',
      YES: 'Sí',
      ZIP: 'Cremallera',

      GETTING_RECORDS: 'Obteniendo registros...',
      GETTING_RFQ_DETAILS: 'Obtener detalles de RFQ...',
    },
    FACTORY: {
      FACTORY_NAME: 'Nombre de la fábrica',
      FACTORY_ADMIN: 'Administrador de fábrica',
      FACTORY_DESCRIPTION: 'Descripción de la fábrica',
    },
    SUPPLIER: {
      SUPPLIER_NAME: 'Nombre de la fábrica',
      SUPPLIER_ADMIN: 'Administrador de fábrica',
      SUPPLIER_DESCRIPTION: 'Descripción de la fábrica',
    },
    ACCOUNT: {
      BUSINESS_DETAILS_TITLE: 'Detalles comerciale',
      BUSINESS_NAME: 'Nombre del Negocio',
      FEIN: 'Número de Identificación del Empleador Federal',
      BUSINESS_TYPE: 'Tipo de negocio',
      PHONE_NUMBER: 'Número de teléfono',
      EXTNAME: 'Nombre ext.',
      FIRSTNAME: 'Primer nombre',
      LASTNAME: 'Apellido',
      MIDDLENAME: 'Segundo nombre',
      LOGIN_EMAIL: 'Dirección de correo electrónico de inicio de sesión',
      MEMBER_STAFF: 'Miembro / Personal',
      SUPPLIER_ADMIN: 'Administrador de fábrica',
      USER_ROLE: 'Rol del usuario',
    },
    ADDRESS: {
      STREET_ADDRESS: 'Dirección',
      BUSINESS_ADDRESS: 'Dirección de Negocios',
      CITY_ADDRESS: 'Dirección de la ciudad',
      STATE_ADDRESS: 'Dirección del estado',
      ZIP_CODE: 'Código posta',
      COUNTRY: 'País',
    },
    CONTACT: {
      PHONE: 'Teléfono',
      MOBILE: 'Móvil',
    },
    FORM: {
      INPUT: {
        CONFIRM_PASSWORD: 'Confirmar contraseña',
        EMAIL: 'Email',
        FULLNAME: 'Nombre completo',
        PASSWORD: 'Contraseña',
        USERNAME: 'Nombre de usuario',
        LANGUAGE: 'Idioma',
        CURRENT_PASSWORD: 'Contraseña actual',
        NEW_PASSWORD: 'Nueva contraseña',
      },
      VALIDATION: {
        AGREEMENT_REQUIRED: 'Se requieren términos y condiciones de aceptación',
        INVALID_FIELD: 'El campo no es valido',
        INVALID_LOGIN: 'El detalle de inicio de sesión es incorrecto',
        INVALID: '{{name}} no es válido',
        MAX_LENGTH_FIELD: 'Longitud máxima del campo:',
        MIN_LENGTH_FIELD: 'Longitud mínima del campo:',
        MIN_LENGTH: '{{name}} longitud mínima es {{min}}',
        MAX_LENGTH: '{{name}} longitud máxima es {{max}}',
        NOT_FOUND: 'Lo solicitado {{name}} no se encuentra',
        REQUIRED_FIELD: 'Campo requerido',
        REQUIRED: '{{name}} es requerido',
        MAX_CHARACTER_LIMIT: 'Maximum field length reached',
      },
    },
    TITLES: {
      ASSIGNED_TO: 'Asignado a',
      CLIENT_PROFILE: 'Perfil del cliente',
      ASSIGN_RFQ_ADMIN: 'Asignar administrador RFQ',
      ASSIGN_RFQ_MEMBER: 'Asignar RFQ al personal',
      ADD_PRODUCT_VARIANT: 'Agregar variante de producto',
      ADD_VARIANTS: 'Agregar variantes',
      ANNUAL_QUANTITY: 'Cantidad anual',
      ATTACH_PRODUCT_FILES: 'Adjuntar archivos / imágenes del producto',
      BUSINESS_INFO: 'Información comercial',
      CART_REVIEW_SIGN: 'Revisar y firmar órdenes de compra',
      CHANNICS_STAFF_DESC: 'Administrar cuentas de personal e iniciar sesión',
      CHANNICS_STAFF: 'Personal Channics',
      CHARGE_AMOUNT: 'Precio a cobrar',
      CHECKOUT_ORDERS: 'Pedido de pedidos',
      CLIENT_NAME: 'Nombre del cliente',
      CONFIRM_ORDER_DETAILS: 'Confirmar detalles del pedido',
      COUNTRY: 'País',
      DATE_CREATED: 'Fecha de creacion',
      DATE_SIGNED: 'Fecha firmada',
      DATE_TIME_CREATED: 'Fecha / hora de creación',
      DATE_TIME: 'Fecha y hora',
      DDP_AIR: 'DDP AIR',
      DDP_SEA: 'DDP SEA',
      EFFECTIVE_DATE: 'Fecha efectiva',
      FILE_REMARKS: 'Observaciones de archivo / Descripción',
      FILE: 'Expediente',
      FILES: 'Archivos',
      FACTORIES: 'Suerte',
      FINAL_DESTINATION_ADDRESS: 'Dirección de destino final',
      FIRST_ORDER_QUANTITY: 'Cantidad primer pedido',
      HAVE_PACKING_REQ: '¿Tienes algún requisito de embalaje?',
      IS_PRIMARY: 'Es primaria',
      LEAD_TIME: 'Tiempo de espera',
      PRODUCTION_LEAD_TIME: 'Tiempo ... de producción',
      MY_COMPLETED_ORDERS: 'Mis pedidos completados',
      MY_PENDING_ORDERS: 'Mis pedidos pendientes',
      MY_PURCHASE_ORDERS: 'Mis ordenes de compra',
      NEGOTIATE_PRICE: 'Negociar precio',
      NEGOTIATED_QUOTE: 'Cantidad negociada y precio',
      NEW_QUOTATION: 'Nueva cita',
      NEW_STAFF: 'Personal nuevo',
      NEW_SUPPLIER: 'Nuevo proveedor',
      NEW_FACTORY: 'Nueva fábrica',
      EDIT_FACTORY: 'Editar fábrica',
      ORDER_AMOUNT: 'Total de la orden',
      ORDER_DETAILS: 'Detalles del pedido',
      ORDER_SAMPLE: 'Muestra de orden',
      ORDER_STATUS: 'Estado del pedido',
      ORDER_VOLUME: 'Volumen de pedido',
      OTHER_DETAILS: 'Otros detalles',
      PACKAGING_DETAILS: 'Detalles del empaque',
      PAYABLE_AMOUNT: 'Cantidad a pagar',
      PAYMENT_DETAILS: 'Detalles del pago',
      PAYMENT_INFO: 'Información de pago',
      PAYMENT_RECEIPTS: 'Recibos de pago',
      PAYMENT_VIA: 'Pago vía',
      PENDING_PURCHASE_ORDERS: 'Órdenes de compra pendientes',
      PO_NUMBER: 'PO Número',
      PRODUCT_ATTACHMENTS: 'Adjuntos de producto',
      PRODUCT_INFO: 'Información del Producto',
      PRODUCT_ORDER_VARIANTS: 'Variantes de pedido de producto',
      PRODUCT_VARIANTS: 'Variantes de producto',
      PROJECTED_DELIVERY: 'Entrega proyectada',
      PURCHASE_ORDER_NUMBER: 'Orden de compra',
      PURCHASE_ORDERS: 'Ordenes de compra',
      QUOTATION_FOR: 'Presupuesto para: ',
      QUOTATIONS: 'Citas',
      REQUEST_FOR_QUOTES: 'Solicitud de cotizaciones',
      RFQ_DETAILS: 'Detalles de RFQ',
      SAMPLE_DETAILS: 'Detalles de muestra',
      SAMPLE_ORDERS: 'Pedidos de muestra',
      SKU: 'SKU',
      SHIP_PACK_DETAILS: 'Detalles de envío y embalaje',
      STATUS: 'Estado',
      TIERED_PRICING: 'Precios diferenciados',
      TOTAL_COST: 'Coste total',
      TOTAL_PAID: 'Total pagado',
      TOTAL_BALANCE: 'Balance total',
      TRACKING_DETAILS: 'Detalles de seguimiento',
      UPDATE_PROFILE: 'Actualización del perfil',
      UPDATE_PURCHASE_ORDER_STATUS: 'Actualizar el estado de la orden de compra',
      UPDATE_QUOTATION: 'Actualizar presupuesto',
      UPLOAD_RECEIPT: 'Cargar recibo',
      USER_DETAILS: 'Detalles de usuario',
      VARIANT_DETAIL: 'Detalle variante',
      VARIANT_NAME: 'Nombre de variante',
      VARIANT_TERMS_VALUES: 'Términos / valores',
      VARIANT_TERMS: 'Términos variantes',
      VIEW_ORDER_STATUS: 'Ver estado del pedido',
      VARIANT_QUOTATIONS_FOR: 'Cotizaciones variantes para ',
      NEW_VARIANT_QUOTATION: 'Nueva cotización variante',
      UPDATE_VARIANT_QUOTATION: 'Actualizar cotización de variante',
      RFQ_VARIANTS: 'Variantes de RFQ',
      QUOTATION_NOTES: 'Notas de cotización',
      VARIANTS: 'Variantes',
    },
    LABELS: {
      PRODUCTION_LEAD_TIME: 'Tiempo ... de producción',
      FACTORY: 'Fábrica',
      ANNUAL_VOLUME: 'Volumen potencial de compra anual',
      ATTACH_PRODUCT_FILES: 'Adjunte en los archivos del producto',
      BUNDLING: 'Agrupación',
      CAN_SEND_SAMPLE_TO_MATCH: '¿Nos puede enviar una muestra para que coincida?',
      CARTON_ARRANGE: 'Arreglo de cartón',
      CHANGES_TO_MAKE: '¿Qué cambios quieres hacer?',
      COST_PER_SAMPLE: 'Costo por muestra',
      COST_PER_UNIT: 'Costo por unidad',
      CUSTOM_PRINTING: 'Impresión personalizada (en cajas o bolsas)',
      DDP_AIR: 'DDP Air',
      DDP_SEA: 'DDP Sea',
      DEPENDS_ON_MOQ: 'Dependerá de MOQ',
      DESTINATION_ADDRESS: 'Dirección de destino',
      DESTINATION_CITY: 'Ciudad de destino',
      DESTINATION_STATE: 'Estado de destino',
      DESTINATION_ZIP: 'Código postal de destino',
      DEVELOPMENT_STATUS: '¿Qué tan avanzado está el desarrollo?',
      DONT_KNOW_YET: 'No lo se todavia',
      EXPIRED: 'Muerta',
      EXPIRY_DATE: 'Fecha de caducidad',
      FIRST_ORDER_QTY: 'Cantidad de primer pedido',
      HAS_INFORMATION_TO_GIVE: '¿Hay alguna otra información que necesite darnos?',
      IS_ARTWORK_AVAILABLE: '¿Tienes obras de arte disponibles?',
      IS_BRAND_PRODUCT:
        '¿Quieres marcar este producto? (ej. logotipos, etiquetas, etiquetas, etc.)',
      IS_NEED_CERTIFICATE:
        '¿Este producto necesita algún certificado especial o prueba?',
      IS_NEED_GRAPHIC_DESIGN: '¿Necesitas ayuda en diseño gráfico o marketing?',
      IS_NEED_HELP_IN_PROTOTYPE:
        '¿Necesita ayuda para crear un dibujo mecánico o prototipo?',
      IS_PRODUCT_IN_MARKETPLACE: '¿Este producto existe en el mercado actual?',
      IS_SOLD_TO_AMAZON: '¿Se venderá en Amazon?',
      IS_WANT_PROFESSIONAL_PICTURES: '¿Quieres fotos de productos profesionales?',
      LABELING: 'Etiquetado / Pegatinas',
      LOGISTICS: 'Logística',
      MOQ_FACTORY: 'Citaremos el MOQ de la fábrica',
      NOT_SURE_WITH_THIS: 'No estoy seguro con esto',
      NOT_SURE: 'No es seguro',
      ORDER_TYPE: 'Tipo de orden',
      OTHER_DIRECTIONS: 'Otras direcciones',
      PER_UNIT: 'Por unidad',
      PRICE_WILL_CHANGE: 'el precio cambiará si esto cambia',
      PRODUCT_CATEGORY: 'Categoria de producto',
      PRODUCT_DESCRIPTION: 'Descripción del producto',
      PRODUCT_HAS_VARIATION: 'Este producto tiene variaciones',
      PRODUCT_MARKET_LINK: 'Proporcione el enlace del producto en el mercado',
      PRODUCT_NAME: 'Nombre del producto',
      QUOTATION_FILES: 'Archivos de cotización',
      QUOTE_GENERIC: 'Citame genérico',
      QUOTE_NEG_CHECKING:
        'Comprobación de la negociación de precios enviada previamente...',
      QUOTE_NEG_COST: 'Costo total por unidad',
      QUOTE_NEG_DIRECTION: 'Otras direcciones',
      QUOTE_NEG_EXISTS: 'Esto ha sido enviado por última vez ',
      QUOTE_NEG_FACTORY_COUNTRY: 'País de fábrica',
      QUOTE_NEG_UNIT_QUANTITY: 'Purchase Units Quantity',
      QUOTE_NEG_VOLUME: '¿Cuántas unidades comprarás?',
      QUOTE_TO_US_LOCATION:
        'Cotizar a una ubicación en el centro de los EE. UU. De forma predeterminada',
      RFQ_FILES: 'Archivos RFQ',
      SAMPLE_LEAD_TIME: 'Muestra de tiempo de entrega (días)',
      SAMPLE_PRICE: 'Precio de muestra',
      TARGET_PRICE: 'Precio objetivo',
      TELL_DETAILS: 'Cuéntanos algunos detalles',
      TOTAL_QUANTITY: 'Cantidad total',
      UNIT_PRICE: 'Precio unitario',
      UNITS: 'Unidades',
      VARIOUS_PREP: 'Varios preparativos',
      WITH_MINOR_CHANGES: 'Similar pero hará cambios menores',
    },
    BUTTONS: {
      UPDATE_VARIANTS: 'Actualizar variantes',
      EDIT_QUOTATION: 'Editar cita',
      DELETE_QUOTATION: 'Eliminar cita',
      EDIT_VARIANT_QUOTATION: 'Editar cita variante',
      DELETE_VARIANT_QUOTATION: 'Eliminar cita variante',
      NEW_VARIANT_QUOTATION: 'Nueva cotización variante',
      ASSIGN_SELECTED_RFQS: 'Asignar RFQ seleccionadas',
      SEARCH: 'Buscar',
      FILTER: 'Filtrar',
      RESET: 'Reiniciar',
      ACCEPT_QUOTE: 'Aceptar cita',
      ADD_NEW_QUOTATION: 'Añadir nueva cita maestra',
      ASSIGN_RFQ_ADMIN: 'Asignar administrador RFQ',
      ASSIGN_RFQ_MEMBER: 'Asignar RFQ al personal',
      VIEW_CLIENT_INFO: 'Ver información del cliente',
      ADD_QUOTATION: 'Agregar cita',
      VIEW_QUOTATION: 'er presupuesto',
      ADD_NEW: 'Añadir nuevo',
      ADD_TERM: 'Agregar término',
      ADD_TO_CART: 'Añadir a la cesta',
      ADD: 'Añadir',
      BACK: 'Atrás',
      CANCEL: 'Cancelar',
      CLOSE: 'Cerca',
      CONFIRM_DELETE_TEXT: 'Sí, bórralo!',
      CONFIRM_DEACTIVATE_TEXT: '¡Sí, desactívelo!',
      CONFIRM_ACTIVATE_TEXT: '¡Sí, actívalo!',
      CONFIRM_MARK_PAID: 'Sí, marcar como PAGADO!',
      CONFIRM_NEW_QUOTE_TEXT: 'Sí, solicite una nueva cotización!',
      CONFIRM_ORDER: 'Confirmar pedido',
      CONFIRM_PAYMENT: 'Confirmar pago',
      CONFIRM_REMOVE_TEXT: '¡Sí, quítalo!',
      CONTINUE: 'Continuar',
      CREATE_RFQ: 'Crear solicitud de cotización',
      EDIT_ORDER: 'Editar orden',
      EDIT_PRODUCT_DETAILS: 'Editar detalles del producto',
      EDIT_SHIPPING_ADDRESS: 'Editar dirección de envío',
      EDIT_SHIPPING_REQUIREMENTS: 'Editar requisitos de envío',
      GO: 'Ir!',
      NEGOTIATE_PRICE: 'Negociar precio',
      NEXT: 'Próxima',
      OKAY: 'Buena',
      ORDER_SAMPLE: 'Muestra de orden',
      POST_QUOTATION: 'Publicar cita',
      RE_ORDER: 'Reordenar',
      REQUEST_QUOTE: 'Solicitar nueva cotización',
      SAVE_AS_DRAFT: 'Guardar como borrador',
      SAVE_CHANGES: 'Guardar cambios',
      SAVE_UPDATES: 'Guardar actualizaciones',
      SAVE: 'Salvar',
      SET_NEW_PASSWORD: 'Establecer nueva contraseña',
      SUBMIT_RFQ: 'Enviar solicitud de cotización',
      UPDATE_ORDER_STATUS: 'Actualizar estado del pedido',
      UPDATE_PURCHASE_ORDER: 'Actualizar orden de compra',
      UPDATE_QUOTATION: 'Actualizar presupuesto',
      UPDATE_SAMPLE_ORDER: 'Actualizar orden de muestra',
      UPDATE: 'Actualizar',
      UPLOAD_RECEIPT: 'Cargar recibo',
      VIEW_PRODUCT_DETAILS: 'Ver detalles del producto',
      VIEW_QUOTE: 'Ver cotizaciones',
      VIEW_RECEIPTS: 'Ver recibos',
      VIEW_RFQ: 'Ver RFQ',
      VIEW_STATUS: 'Ver el estado de',
      VIEW: 'Ver',
    },
    MESSAGES: {
      ATTACHMENT_REQUIRED: 'Se requiere al menos un archivo adjunto.',
      CARD_ERROR: 'Error en la tarjeta',
      CONFIRM_DELETE_QUOTE: '¿Eliminar cita de {{country}}?',
      CONFIRM_PO_PAYMENT:
        '¿Confirmar pago por número de pedido PO {{po_number}} del cliente {{client}}?',
      CONFIRM_QUOTE_DELETE:
        '¿Eliminar solicitud de presupuesto para {{product_name}}?',
      ORDER_COMPLETE: 'Orden completada. Su orden esta siendo procesada.',
      PAYMENT_COMPLETE: 'Pago completo Su orden esta siendo procesada.',
      PO_PAYMENT_CONFIRMED: 'Pago confirmado y publicado con éxito.',
      QUOTE_UPDATED: 'Cita actualizada!',
      REMOVE_FROM_LIST: '¿Retirar {{text}} de la lista?',
      SENDING_REQUEST_TEXT: 'Enviando solicitud, por favor espere...',
      SET_CORRECT_STATUS_DATE:
        'Establezca la fecha correcta para que se actualice el estado.',
      STRIPE_CARD_ERROR: 'Error de tarjeta STRIPE',
      VARIANT_TERM_REQUIRED: 'Agregue al menos 1 término variante.',

      CLICK_TO_VIEW: 'Haga clic para verlo.',

      QUOTATION_VARIANT: {
        TITLE: 'Se requiere la variante de RFQ.',
        TEXT: 'Establezca al menos una (1) variante para continuar.',
      },
      RFQ_STAFF_ERROR: {
        TITLE: 'Se requiere al menos un personal.',
        TEXT: 'Por favor verifique al menos un miembro del personal para continuar.',
      },
      FILE_MAX_SIZE_ERROR: {
        TITLE: 'Error de tamaño máximo de archivo',
        TEXT: 'El archivo a adjuntar no debe exceder los 10 MB.',
      },
      CONFIRM_DELETE_ROW: {
        TITLE: '¿Borrar {{name}}?',
        TEXT: 'Una vez eliminado Este registro no se puede recuperar.',
      },
      CONFIRM_DEACTIVATE_ROW: {
        TITLE: 'Desactivar {{name}}?',
        TEXT: 'El inicio de sesión se desactivará para esta cuenta. El registro desactivado se puede activar.',
      },
      CONFIRM_ACTIVATE_ROW: {
        TITLE: 'Activar {{name}}?',
        TEXT: 'El inicio de sesión se habilitará para esta cuenta.',
      },
      UPLOAD_RECEIPT_SUCCESS: {
        TITLE: '¡Subida exitosa!',
        TEXT: 'Recibo cargado correctamente.',
      },
      LOGISTICS_REQUIRED: {
        TITLE: '¡Se requiere logística!',
        TEXT: 'Seleccione la logística de este pedido.',
      },
      QUANTITY_ERROR: {
        TITLE: 'Error de cantidad!',
        TEXT: 'La cantidad del pedido debe ser mayor que cero (0).',
      },
      CART_SIGNED: {
        TITLE: '¡Firma éxito!',
        TEXT: 'Pedido de carro firmado y guardado con éxito.',
      },

      CART_ORDER_CREATED: {
        TITLE: '¡Crea con éxito!',
        TEXT: 'Pedido agregado al carrito.',
      },
      CART_ORDER_UPDATED: {
        TITLE: '¡Actualización exitosa!',
        TEXT: 'Pedido de carro actualizado.',
      },

      QUOTE_UPDATED_NOT_AVAILABLE: {
        TITLE: 'Cotizaciones actualizadas o no disponibles!',
        TEXT: 'No se puede proceder con el pedido de este producto ya que la Solicitud de cotización se actualizó y aún está esperando nuevas cotizaciones. Puede reordenar una vez que haya nuevos presupuestos disponibles',
      },
      QUOTE_REQUEST_SENT: {
        TITLE: 'Solicitud enviada',
        TEXT: 'Su solicitud de nueva cotización ha sido enviada.',
      },
      QUOTE_EXPIRED: {
        TITLE: 'Cita expirada',
        TEXT: 'Esta cita ya ha expirado. Puede solicitar un nuevo presupuesto para este producto.',
        PRODUCT_QUOTE_EXP:
          'La cotización para este pedido ya ha expirado. Puede solicitar un nuevo presupuesto para este producto.',
      },
      UPDATE_SUCCESS: {
        TITLE: 'Actualización exitosa!',
        TEXT: 'Registro actualizado con éxito.',
      },
      CREATE_SUCCESS: {
        TITLE: 'Creado con éxito!',
        TEXT: 'El registro ha sido creado.',
      },
      SAVE_SUCCESS: {
        TITLE: 'Se guardo correctamente!',
        TEXT: 'Registro guardado con éxito.',
      },
      DELETE_SUCCESS: {
        TITLE: 'Eliminar con éxito!',
        TEXT: 'Registro eliminado con éxito.',
      },
      DEACTIVATE_SUCCESS: {
        TITLE: '¡Desactivación exitosa!',
        TEXT: 'Cuenta desactivada con éxito.',
      },
      ACTIVATE_SUCCESS: {
        TITLE: 'Acitavtion Exitosa!',
        TEXT: 'Cuenta activada con éxito.',
      },
      SERVER_TRANSACTION_ERROR: {
        TITLE: 'Error de transacción!',
        TEXT: 'An error occured while trying to save order. Please try again later or contact support.',
      },
      SERVER_SAVE_ERROR: {
        TITLE: 'Guardar error!',
        TEXT: 'Error al guardar el registro. Vuelva a intentarlo más tarde o póngase en contacto con el servicio de asistencia.',
      },
      REGISTER_ERROR: {
        TITLE: 'Error de registro!',
        TEXT: 'Correo electrónico ya en uso. Por favor use otra dirección de correo electrónico.',
      },
      REGISTER_SUCCESS: {
        TITLE: 'Registrado exitosamente!',
        TEXT: 'Ahora puede iniciar sesión con su nueva cuenta.',
      },
      ACCEPT_TERMS: {
        TITLE: 'Aceptar terminos y condiciones!',
        TEXT: 'Por favor lea y acepte los términos y condiciones.',
      },
      INVALID_LOGIN: {
        TITLE: 'Error de inicio de sesión!',
        TEXT: 'Usuario o contraseña invalido.',
      },
      PASSWORD_RECOVERY: {
        TITLE: 'Recuperación de contraseña!',
        TEXT: 'Las instrucciones y el enlace para recuperar su contraseña han sido enviados a su correo electrónico.',
      },
      PASSWORD_SAVED: {
        TITLE: 'Contraseña guardada!',
        TEXT: 'Ahora puede iniciar sesión con su nueva contraseña.',
      },
      FORM_ERROR: {
        TITLE: 'Error de formulario!',
        TEXT: 'Por favor llene todos los campos requeridos.',
      },
    },
    QUOTE_STATUS: {
      OUT_FOR_QUOTE: 'Fuera de cotización',
      QUOTE_AVAILABLE: 'Presupuesto disponible',
      QUOTES_AVAILABLE: 'Cotizaciones disponibles',
      ORDER_PLACED: 'Pedido realizado',
      ORDER_CONFIRMED: 'Orden confirmada',
      SAMPLE_ORDERED: 'Muestra ordenada',
      NEGOTIATED_PRICE: 'Precio negociado',
      DRAFT: 'Borrador',
      POSTED: 'Al corriente',
      EXPIRES_ON: 'Expira el ',
      PRICE_REQUEST: 'Precio requerido',
      VARIANT_QUOTES: 'Ver cotizaciones de variantes',
    },
    ORDER_STATUS: {
      AAA: 'Todas las órdenes',
      PENDING: 'En espera de pago',
      ACTIVE: 'Pedido realizado',
      ORDER_PLACED: 'Pedido realizado',
      ESTIMATED_ARRIVAL: 'Hora estimada de llegada',
      SAMPLE_SENT: 'Muestra enviada',
      SAMPLE_RECEIVED: 'Muestra recibida',
      PRE_PRODUCTION_CONFIRMED: 'Detalles de preproducción confirmados',
      PRODUCTION_STARTED: 'Producción iniciada',
      PRODUCTION_COMPLETED: 'Producción completada',
      IN_TRANSIT: 'En tránsito',
      DELIVERED: 'Entregado',
      RECEIPTS_UPLOADED: 'Recibos subidos',
    },
    LOGISTICS: {
      DDP_AIR: 'DDP AIR',
      DDP_SEA: 'DDP SEA',
      FOB: 'FOB',
      EXW: 'EXW',
    },
    NOTIF: {
      TITLE: 'Notificaciones',
      NEW_RFQ: 'presentó una nueva solicitud de presupuesto para el producto ',
      PRICE_NEG:
        'Se ha enviado una negociación de precio para su cotización del producto ',
      RFQ_ASSIGNED:
        '<i>La RFQ para producto </i> <b> {{product_name}} </b> <i> te ha sido asignado.</i>',
      RFQ_UPDATED:
        '<i>Los detalles de la RFQ se han actualizado para el producto </i> <b> {{product_name}} </b>.',
      RFQ_REQUOTE:
        '<i>Se ha solicitado un nuevo presupuesto para el producto </i> <b> {{product_name}} </b>.',
      NEW_ORDER:
        '<i>Nuevo pedido de producto </i> <b> {{product_name}} </b> <i> ha sido presentado por <b>{{client_name}}</b>.</i>',
      RECEIPT_UPLOADED: 'Nuevo recibo cargado para pedido con número de pedido ',
      KIT_ASSIGNED:
        '<i>La KIT para producto </i> <b> {{product_name}} </b> <i> te ha sido asignado.</i>',
    },
    SETTINGS: {
      SAVE_SETTINGS: 'Guardar ajustes',
      TITLE: 'Ajustes del sistema',
      LABEL: 'Detalle de términos',
      LABEL_MARKUP: 'Detalle de marcado',
      MIN_ORDER: 'La orden mínima',
      MAX_ORDER: 'Orden máxima',
      DOWNPAYMENT: 'Pago inicial',
      FINAL_PAYMENT: 'Pago final',
      MARKUP: 'Margen',
      PAYMENT_TERMS: 'Términos de pago',
      MARK_UP_STRUCTURE: 'Estructura de marcado',
      LEAD_TIMES: 'Tiempos de entrega predeterminados',
      SHIPPING_SEA: 'Plazo de entrega por mar',
      SHIPPING_AIR: 'Plazo de entrega por aire',
      SHIPPING_FOB: 'Plazo de ejecución por FOB',
      SHIPPING_CIF: 'Plazo de ejecución por CIF',
      MESSAGE_SAVE: {
        TITLE: 'Guardar el éxito',
        TEXT: 'La configuración del sistema se guardó correctamente',
      },
    },
    TEXT: {
      VARIANT_QUOTE_TYPE_ALL_DIFFERENT:
        'Todas las variantes tienen precios diferentes',
      VARIANT_QUOTE_TYPE_ALL_SAME: 'Todas las variantes tienen el mismo precio',
      VARIANT_QUOTE_TYPE_SOME_DIFFERENT:
        'Algunas variantes tienen precios diferentes',
      CHECKOUT_NO_PRODUCT:
        'No hay productos firmados para pagar. Firme primero sus productos, luego finalice la compra y pague.',
      CONFIRM_ORDER_DETAILS:
        'Aquí están los detalles del pedido que ha ingresado. Continúe si estos son correctos o edite para actualizar algunos detalles.',
      CONFIRM_PRODUCT_DETAILS:
        'Aquí está toda la información del producto que ingresó en su RFQ, ¿son correctas todas estas variaciones? Si hay variaciones de tamaño o color, ¿ha proporcionado una amplia información detallada a la fábrica aquí (es decir, colores pantone, dibujos, dimensiones, etc.)? Si no, edítelo ahora o haga clic en continuar.',
      CONFIRM_SHIPPING_ADDRESS:
        '¿Aquí está la dirección de envío que nos proporciona, ¿es correcta? ¿Necesitas cambiar la dirección? ¿Tiene más de una dirección de envío? En caso afirmativo, edite ahora o confirme este orden para continuar.',
      CONFIRM_SHIPPING_REQUIREMENTS:
        'Estos son los requisitos de envío que anotó originalmente, ¿está seguro de que estos son sus requisitos de envío finales? Si no, edítelo ahora o haga clic en continuar',
      ENTER_NAME: '(Introduzca su nombre)',
      QUOTE_NEG_TITLE:
        'Indíquenos su costo objetivo por unidad y trabajaremos para obtener un mejor precio.',
      REVIEW_SIGN_TEXT:
        'He revisado la información anterior y he verificado que es correcta. Autorizo ​​a Yama a crear una orden de compra.',
      REVIEW_VERIFY_TEXT:
        'Revisé toda la información y verifiqué que es correcta. Autoricé a Yama para crear una orden de compra.',
      TOTAL_ORDER_AMOUNT: 'Monto total del pedido',
      TOTAL_PAYABLE_AMOUNT: 'Monto total a pagar',
      WIRE_PAYMENT_DESC:
        'Se le enviará un correo electrónico con instrucciones detalladas sobre cómo pagar esta orden de compra mediante transferencia bancaria junto con el número de pedido.',
      WIRE_PAYMENT: 'Pago por transferencia bancaria',

      OD_SAMPLE_TO_WATCH: 'Con muestra a juego',
      OD_SOLD_TO_AMAZON: 'Se venderá en Amazon',
      OD_HELP_IN_MECHANICAL_PROTOTYPE:
        'Necesita ayuda para crear dibujos mecánicos o prototipos',
      OD_HELP_IN_GRAPHIC_DESIGN: 'Necesita diseño gráfico o ayuda de marketing',
      OD_NEED_CERTIFICATES:
        'El producto necesita certificados especiales o pruebas',
      OD_WANT_PROFESSIONAL_PICTURES: 'Quiere fotos de productos profesionales',

      SR_LABELING: 'Etiquetado / Pegatinas',
      SR_PRINTING: 'Impresión personalizada (en cajas o bolsas)',
      SR_BUNDLING: 'Agrupación',
      SR_VARIOUS_PREP: 'Varios preparativos',
      SR_CARTON: 'Arreglo de cartón',
      SR_GENERIC: 'Citame Genérico',

      PD_PRODUCT_ON_MARKET: 'Existe el producto en el mercado',
      PD_DEVELOPMENT_STATUS: 'Estado del desarrollo',
      PD_PRODUCT_LINK: 'Enlaces de producto',
      PD_PRODUCT_LISTINGS: 'Enlaces del producto en otros mercados',
      PD_CHANGES_TO_MAKE: 'Cambios a realizar',
      PD_MINOR_CHANGES: 'Similar pero hará cambios menores',
      PD_BRAND_PRODUCT:
        'Quiere marcar este producto (logotipos, etiquetas, etiquetas, etc.)',
      PD_ART_AVAILABLE: 'Arte disponible como adjunto',

      CONFIRM_ORDER:
        'Debido a que ha cambiado los detalles originales de la cotización, tendremos que volver a confirmar con la fábrica y actualizar la cotización. Puede volver a crear su pedido una vez que las cotizaciones estén actualizadas y disponibles',
      SEARCH_FOR_PRODUCT: 'Buscar producto...',

      EDIT_RECORD: 'Editar registro',
      DELETE_RECORD: 'Eliminar el registro',
      SELECT_PRODUCT: 'Buscar producto',
    },

    RFQ: {
      QUOTE_TYPE_TITLE: 'Solicitud de tipo de cotización',
      QUICK_QUOTE: 'Nota rapida',
      PRODUCT_RECOMMENDATION: 'Recomendación de producto',
      EXACT_QUOTE: 'Presupuesto exacto',
    },

    CLIENTS: {
      UPDATE_PROFILE: 'Actualización del perfil',
      TITLES: 'Clientes de Source Channics',
      TITLE_DESC: 'Gestionar registros de clientes',
      BUSINESS_NAME: 'Nombre del Negocio',
      BUSINESS_TYPE: 'Tipo de negocio',
      BUSINESS_ADDRESS: 'Dirección de Negocios',
      CITY: 'Ciudad',
      STATE: 'Estado',
      ZIP: 'Código Postal',
      PHONE: 'Teléfono',
      QUOTATION_REQUESTS: 'Solicitudes de cotización',
      PENDING_ORDERS: 'Ordenes pendientes',
      ACTIVE_ORDERS: 'Órdenes activas',
      PURCHASE_ORDERS: 'Ordenes de compra',
      PROFILE: 'Perfil',
      BUSINESS_DETAILS: 'Detalles comerciales',
      ACCOUNT_INFO: 'Informacion de cuenta',
      PENDING_RFQS: 'RFQ pendientes',
      SHIPPING_DETAILS: 'Detalles de envío',
      SHIPPING_ADDRESS: 'Dirección de Envío',
      SHIPPING_CITY: 'Ciudad de envío',
      SHIPPING_STATE: 'Estado de envío',
      SHIPPING_ZIP: 'Zip de envío',
      SHIPPING_COUNTRY: 'País de envío',
    },
  },
};
